import { metaTagString } from '../../utilities/meta_tags_util';
import { getLanguageByRank } from '../../utilities/language';

export default (urlPath, language, query, params, headers) => {
  let metaData = '';
  const metaLanguage = getLanguageByRank(
    query.hl,
    null,
    headers['accept-language'],
  );
  switch (metaLanguage) {
    case 'zh': {
      metaData += metaTagString({
        urlPath,
        title: '體驗各種美好生活',
        description: '線上預訂景點票券、當地體驗、旅遊行程、租車、包車導遊， Funliday 讓你為旅遊輕鬆做準備！',
        language,
        images: ['https://assets.funliday.com/web/img_experiences.jpg'],
      });

      break;
    }
    case 'zh-cn': {
      metaData += metaTagString({
        urlPath,
        title: '体验各种美好生活',
        description: '线上预订景点票券、当地体验、旅游行程、租车、包车导游， Funliday 让你为旅游轻松做准备！',
        language,
        images: ['https://assets.funliday.com/web/img_experiences.jpg'],
      });

      break;
    }
    case 'zh-tw': {
      metaData += metaTagString({
        urlPath,
        title: '體驗各種美好生活',
        description: '線上預訂景點票券、當地體驗、旅遊行程、租車、包車導遊， Funliday 讓你為旅遊輕鬆做準備！',
        language,
        images: ['https://assets.funliday.com/web/img_experiences.jpg'],
      });

      break;
    }
    case 'ja': {
      metaData += metaTagString({
        urlPath,
        title: 'いろんなアクティビティ が満載',
        description: 'Funlidayなら入場券、アクテビティ、日帰りツアー、レンタカー、チャーター、ガイドなどが予約でき、旅行の準備がより一層簡単に',
        language,
        images: ['https://assets.funliday.com/web/img_experiences.jpg'],
      });

      break;
    }
    case 'ko': {
      metaData += metaTagString({
        urlPath,
        title: '독특한 현지 체험을 찾기',
        description: '티켓, 현지 체험, 렌터카, 전세 여행 가이드 등을 예약하세요!',
        language,
        images: ['https://assets.funliday.com/web/img_experiences.jpg'],
      });

      break;
    }
    case 'en-us': {
      metaData += metaTagString({
        urlPath,
        title: 'Enjoy your trip like a local',
        description: 'Book attraction tickets, local experience, car rental, chartered tour guide, and more!',
        language,
        images: ['https://assets.funliday.com/web/img_experiences.jpg'],
      });

      break;
    }
    default: {
      metaData += metaTagString({
        urlPath,
        title: '體驗各種美好生活',
        description: '線上預訂景點票券、當地體驗、旅遊行程、租車、包車導遊， Funliday 讓你為旅遊輕鬆做準備！',
        language,
        images: ['https://assets.funliday.com/web/img_experiences.jpg'],
      });

      break;
    }
  }

  return {
    metaData,
  };
};
